import React, { useContext, useState, useEffect, useRef } from 'react';
import filter_sorting from '../../../constants/filter_sorting.json';
import { ListingMapContext } from '../../../context/ListingMapContext.js';
import useOutsideClick from '../../../hooks/useOutsideClick';
import WindowQuery from '../../../utils/WindowQuery';

export default function SortDropdown({ mapType }) {
  const updateQuery = new WindowQuery();
  const dropdownRef = useRef();

  const {
    setListingSortBy,
    setRentalSortBy,
    setDropdown,
    rentalSortBy,
    listingSortBy,
    sortByVisible,
  } = useContext(ListingMapContext);

  const [localSortBy, setLocalSortBy] = useState('');

  useEffect(() => {
    if (mapType === 'rentals') setLocalSortBy(rentalSortBy);
    else setLocalSortBy(listingSortBy);
  }, [listingSortBy, mapType, rentalSortBy, setLocalSortBy]);

  useOutsideClick(dropdownRef, sortByVisible, () => setDropdown(null));

  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Sort By</h2>
      <button
        aria-label="Clear Sort Dropdown"
        name="Clear Sort Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => {
          if (mapType === 'rentals') setLocalSortBy(rentalSortBy);
          else setLocalSortBy(listingSortBy);
          setDropdown(null);
        }}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs">
        {filter_sorting
          .filter(type => type.type === mapType)
          .map(type => (
            <label key={type.value} htmlFor={`filters-type-${type.value}`}>
              <input
                aria-label={`${type.label}`}
                id={`filters-type-${type.value}`}
                type="checkbox"
                checked={localSortBy === type}
                onChange={() => {
                  if (type === localSortBy) {
                    setLocalSortBy();
                  } else {
                    setLocalSortBy(type);
                  }
                }}
              />
              <p>{type.label}</p>
            </label>
          ))}
      </section>
      <section className="dropdown-actions mobile-center">
        <button
          aria-label="Apply Sort Filter"
          name="Apply Sort Filter"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            if (localSortBy) {
              if (mapType === 'rentals')
                updateQuery.add('rentals_sort_by', localSortBy.value);
              if (mapType === 'listings')
                updateQuery.add('listings_sort_by', localSortBy.value);
            } else {
              if (mapType === 'rentals') updateQuery.remove('rentals_sort_by');
              if (mapType === 'listings')
                updateQuery.remove('listings_sort_by');
            }

            if (mapType === 'rentals') setRentalSortBy(localSortBy);
            else setListingSortBy(localSortBy);

            setDropdown(null);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Sort Filter"
          name="Clear Sort Filter"
          type="button"
          className="btn btn--light"
          onClick={() => {
            if (mapType === 'rentals') {
              setRentalSortBy(null);
              updateQuery.remove('rentals_sort_by');
            } else {
              setListingSortBy(null);
              updateQuery.remove('listings_sort_by');
            }
            setLocalSortBy('');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
